import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_INTERNKODER_ILEGGELSER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/ileggelseinternkoder`;
export const POST_INTERNKODER_ILEGGELSER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/ileggelseinternkoder`;
export const PUT_INTERNKODER_ILEGGELSER_URL = (id) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/ileggelseinternkoder/${id}`;
